'use client'

import {Bounce, ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const PageToastify = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={500}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      transition={Bounce}
    />
  )
}
